module.exports = __webpack_public_path__ + "static/Golem_Flesh-210469025433d5f3b6faebb9127f714d.jpg";